
import OpenEngineerApi from '@/api/OpenEngineerApi';
import { AccountModule, ServiceDeskType, arr2TreeList } from '@/store/modules/account.module';
import { message } from 'ant-design-vue';
import { computed, defineComponent, ref, toRefs } from 'vue';

const columns = [
  { title: '账号', width: 100, dataIndex: 'name', ellipsis: true },
  { title: '部门', width: 100, dataIndex: 'groupNames', ellipsis: true },
  { title: '状态', width: 100, dataIndex: 'status' }
];
export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedAccounts: {
      type: Array,
      default: () => []
    },
    // serviceDeskStatus 查询客服组启用状态，1启用，0停用，0,1就查询所有状态的数据
    serviceDeskStatus: {
      type: String
    }
  },
  setup (props, { emit }) {
    const { selectedAccounts } = toRefs(props)
    const treeData = computed(() => {
      const list = JSON.parse(JSON.stringify(serviceDeskList.value));
      return arr2TreeList(list);
    })
    const serviceDeskList = ref<Array<ServiceDeskType>>([]) // 部门数据 
    const selectedGroupIds = ref<any>({
      checked: [],
      halfChecked: []
    })
    const defaultServiceDeskId = ref()
    const isLoading = ref(false);
    const sortGroupResult = ref<Array<any>>([]) // 分组结果 
    const showModal = computed({
      get () {
        return props.visible
      },
      set (value) {
        emit('update:visible', value)
      }
    })

    const selectedGroups = computed(() => {
      return serviceDeskList.value.filter(item => selectedGroupIds.value.checked.indexOf(item.id) > -1)
    })

    const replaceFields = {
      title: 'name',
      key: 'id'
    };

    if (props.serviceDeskStatus !== undefined) {
      AccountModule.getServiceDeskList({ serviceDeskStatus: props.serviceDeskStatus }).then((res):void => {
        serviceDeskList.value = res as Array<ServiceDeskType>;
      });
    } else {
      AccountModule.getServiceDeskList().then((res):void => {
        serviceDeskList.value = res as Array<ServiceDeskType>;
      });
    }

    function handleOk () {
      const serviceDeskIds = selectedGroups.value.map(item => item.id)
      const serviceDeskNames = selectedGroups.value.map(item => item.name).join('、')
      if (serviceDeskIds.length === 0) {
        message.error('请选择要分派的部门')
        return
      }
      if (!defaultServiceDeskId.value) {
        message.error('请勾选首选客服组')
        return
      }

      sortGroupResult.value = []
      isLoading.value = true
      const len = selectedAccounts.value.length
      selectedAccounts.value.forEach((item: any, index: number) => {
        OpenEngineerApi.updateServiceDesks({
          engineerId: item.id,
          defaultServiceDeskId: defaultServiceDeskId.value,
          serviceDeskIds
        }).then(() => {
          sortGroupResult.value.push({ name: item.userName, groupNames: serviceDeskNames, status: 'success' })
        }).catch(() => {
          sortGroupResult.value.push({ name: item.userName, groupNames: serviceDeskNames, status: 'error' })
        }).finally(() => {
          if (index === len - 1) {
            isLoading.value = false
            emit('refresh')
          }
        })
      })
    }

    function handleCancelAll () {
      selectedGroupIds.value.checked = []
      defaultServiceDeskId.value = null
    }

    function handleSure () {
      showModal.value = false
      defaultServiceDeskId.value = null
      sortGroupResult.value = []
      selectedGroupIds.value.checked = []
    }

    function handleCheckDefault (checkedKeys) {
      const index = checkedKeys.checked.indexOf(defaultServiceDeskId.value) 
      if (index === -1) {
        defaultServiceDeskId.value = null
      }
    }

    return {
      columns,
      showModal,
      treeData,
      serviceDeskList,
      replaceFields,
      selectedGroupIds,
      selectedGroups,
      defaultServiceDeskId,
      isLoading,
      sortGroupResult,
      handleOk,
      handleCancelAll,
      handleSure,
      handleCheckDefault
    }
  }
})
